import { render, staticRenderFns } from "./WatchLaptopInstructions.vue?vue&type=template&id=66196dda&scoped=true&"
import script from "./WatchLaptopInstructions.vue?vue&type=script&lang=js&"
export * from "./WatchLaptopInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66196dda",
  null
  
)

export default component.exports